<template>
  <RouterView v-if="isBrandReady" />
  <Toasts v-if="isBrandReady" />
</template>
<script setup>
import { RouterView } from "vue-router";
import { inject } from "vue";
import brandconfig from "@/brandconfig";
import { useBrand } from "@/composable/brand";
import { Toasts } from "@xs2event/js-lib/toast";
import { useVersionChecker } from "@/helpers/version.tsx";

useVersionChecker();

const { primary, secondary, fontFamily, isBrandReady } = useBrand();

if (brandconfig.GA_ID) {
  inject("gtag");
}
</script>

<style scoped>
* {
  --color-primary: v-bind(primary);
  --color-secondary: v-bind(secondary);
}

:first-child {
  font-family: v-bind(fontFamily);
}
</style>
